import { twMerge } from 'tailwind-merge';
import { type FC } from 'react';
import { Text } from 'Text';
import { type ContentItemBoxProps } from './ContentItemBox.types';

export const ContentItemBoxText: FC<{
    title: string;
    titleSize: ContentItemBoxProps['titleSize'];
    subtitle: string | undefined;
}> = ({ titleSize, subtitle, title }) => {
    const titleClass = twMerge(
        titleSize === 'base' ? 'text-base' : 'text-xs',
        'leading-[1.25]',
        subtitle && 'md:leading-none md:mb-0.5',
    );
    const subtitleClass = twMerge(titleSize === 'base' ? 'text-base' : 'text-xs', 'leading-[1.25] md:leading-none');

    return (
        <div className="flex flex-grow flex-col">
            <Text color="black" weight="medium" className={titleClass}>
                {title}
            </Text>
            {subtitle && (
                <Text color="purple" weight="normal" className={subtitleClass}>
                    {subtitle}
                </Text>
            )}
        </div>
    );
};
